import styled from "styled-components";

const AdminSectionHeader = styled.div`
  margin-bottom: 0.9rem;

  h4 {
    margin: 0.45rem 0 0;
    font-size: 1rem;
    font-weight: 950;
  }

  p {
    margin: 0.45rem 0 0;
    font-size: 0.86rem;
    opacity: 0.78;
    line-height: 1.45;
  }
`;

export default AdminSectionHeader;
